var exports = {
  "x6": "MemberListItem.module__button___N1JQdU",
  "OG": "MemberListItem.module__nameRoleColored___N1JQdU",
  "w1": "MemberListItem.module__buttonOffline___N1JQdU",
  "dP": "MemberListItem.module__buttonContextMenuOpen___N1JQdU",
  "vs": "MemberListItem.module__memberFocusRing___N1JQdU",
  "Vg": "MemberListItem.module__grid___N1JQdU",
  "Qs": "MemberListItem.module__content___N1JQdU",
  "H": "MemberListItem.module__avatarContainer___N1JQdU",
  "TT": "MemberListItem.module__userInfoContainer___N1JQdU",
  "VW": "MemberListItem.module__nameContainer___N1JQdU",
  "UU": "MemberListItem.module__name___N1JQdU",
  "w4": "MemberListItem.module__memberCustomStatus___N1JQdU",
  "Dd": "MemberListItem.module__ownerIcon___N1JQdU",
  "j$": "MemberListItem.module__crownIcon___N1JQdU",
  "a1": "MemberListItem.module__userTag___N1JQdU",
};

module.exports = exports;
